export default { inboundTransmission: {} };